import { Route, Routes } from "react-router-dom";
import Home from "./pages/home/home";
import Profile from "./pages/profile/profile";
import { ProfileProvider } from "./context/ProfileContext";
import "./App.css";
import WordPrompt from "./pages/word-prompt/WordPrompt";
import TeacherDashboard from "./pages/teacher-dashboard/page";
import MyCollectibles from "./pages/collectables/collectables";
import Leaderboard from "./pages/leaderboard/leaderboard";
import { useEffect, useRef } from "react";
import { initialSetup } from "./services/backend/api";

function App() {
  const isInitilized = useRef(false);
  useEffect(() => {
    if (isInitilized.current) return;
    isInitilized.current = true;
    (async () => {
      await initialSetup();
    })();
  }, []);
  return (
    <ProfileProvider>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/word-prompt" element={<WordPrompt />} />
        <Route path="/teacher-dashboard" element={<TeacherDashboard />} />
        <Route path="/collectables" element={<MyCollectibles />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        {/* Add more routes as needed */}
      </Routes>
    </ProfileProvider>
  );
}

export default App;
